<script setup lang="ts">
import type { AccordionItemProps } from 'reka-ui'
import type { ButtonColors, ButtonShades, ButtonSizes } from '~/components/ui/Button.vue'
import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
  useForwardProps
} from 'reka-ui'
import { faChevronDown } from '@fortawesome/duotone-regular-svg-icons'
import Button from '~/components/ui/Button.vue'

const props = defineProps<AccordionItemProps & { title: string, color?: ButtonColors, size?: ButtonSizes, shade?: ButtonShades }>()

const forward = useForwardProps(props)
</script>

<template>
  <AccordionItem v-bind="forward">
    <AccordionHeader>
      <AccordionTrigger as-child>
        <Button
          full-width
          :color
          :size
          :shade
          class="group justify-between"
        >
          {{ title }}
          <font-awesome-icon :icon="faChevronDown" class="transition-all duration-150 group-data-[state=open]:rotate-180" />
        </Button>
      </AccordionTrigger>
    </AccordionHeader>
    <AccordionContent class="data-[state=closed]:animate-accordion-close data-[state=open]:animate-accordion-open mt-4 overflow-hidden">
      <slot />
    </AccordionContent>
  </AccordionItem>
</template>
